import {useTranslation} from "react-i18next";
import {FC} from "react";
import {Alert, Card, Col, Container, Row} from "react-bootstrap";
import {useLocation} from "react-router-dom";

type ErrorComponentProps = Record<string, unknown>

const ErrorComponent: FC<ErrorComponentProps> = () => {
    const {t} = useTranslation();
    const {state} = useLocation();
    return (
        <div className="component">
            <Container>
                <Row className="d-flex justify-content-center">
                    <Col xs={6}>
                        <Card>
                            <Card.Header>
                                <h1>{t("error.title")}</h1>
                            </Card.Header>
                            <Card.Body>
                                <Alert variant="danger">
                                    {state.msg}
                                </Alert>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default ErrorComponent;
